/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DTOSalaryHistory from './DTOSalaryHistory';
import SalaryHistoryPresenter from './SalaryHistoryPresenter';

function SalaryHistoryController() {
  const { t } = useTranslation();
  const [prevAllowances, setPrevAllowances] = useState([]);
  const [prevAdditionalBenefits, setPrevAdditionalBenefits] = useState([]);
  const [sortedList, setSortedList] = useState([]);
  const [currency, setCurrency] = useState('');

  function callBackFuncPrevAllowance(data: any) {
    setPrevAllowances(data);
  }
  function callBackFuncAdditionalBenefits(data: any) {
    setPrevAdditionalBenefits(data);
  }
  function getCurrency(data: any) {
    setCurrency(data);
  }

  useEffect(() => {
    const _mergeArray = [...prevAdditionalBenefits, ...prevAllowances];
    const _sortedList = _.sortBy(_mergeArray, ['created_at']).reverse();
    setSortedList(_sortedList);
  }, [prevAllowances, prevAdditionalBenefits]);

  return (
    <>
      <DTOSalaryHistory
        setCurrency={getCurrency}
        setAllPrevAdditionalBenefits={callBackFuncAdditionalBenefits}
        setAllPrevAllowances={callBackFuncPrevAllowance}
      />
      <SalaryHistoryPresenter
        allPrevAdditionalBenefitsData={prevAdditionalBenefits}
        allPrevAllowancesData={prevAllowances}
        currency={currency}
        sortedList={sortedList}
        trans={t}
      />
    </>
  );
}

export default SalaryHistoryController;
